import { enrollmentType } from "../const/enrollmentConsts";
var changeEnrollmentStatus = function (type) {
    var ELECTRONIC = enrollmentType.ELECTRONIC, PAPER = enrollmentType.PAPER, ELECTRONIC_AND_PAPER = enrollmentType.ELECTRONIC_AND_PAPER;
    switch (type) {
        case ELECTRONIC:
            return PAPER;
        case PAPER:
            return ELECTRONIC;
        case ELECTRONIC_AND_PAPER:
            return ELECTRONIC_AND_PAPER;
        default:
            throw new Error("invalid enrollment type");
    }
};
export default changeEnrollmentStatus;
